/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/styles";
import { CardHeader, Divider } from "@material-ui/core";
import ViewListIcon from "@material-ui/icons/ViewList";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import scanImg from "../../../../assets/images/scan.png";
import nonScannedImg from "../../../../assets/images/nonScan.png";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import cameraImg from "../../../../assets/images/camera.png";
import { IsEmpty } from "../../../../utils/helper";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    // height: "100%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "100%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
  },
  cardContent: {
    padding: 0,
    width: "97%",
    marginLeft: 20,
    overflow: "auto",
    height: "100%",
  },
  listItem: {
    outline: "none",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,
  },
  listItemScanned: {
    outline: "none",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,
  },
  listItemNONScanned: {
    outline: "none",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,

    color: "darkgray",
  },
  listItemContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: 10,
    alignItems: "center",
  },
  listItemKey: {
    fontSize: 14,
    textAlign: "left",
    fontWeight: 600,
    width: "20%",
  },
  listItemValue: {
    fontSize: 13,
    textAlign: "left",
    width: "20%",
  },
  halfWidthRight: {
    width: "50%",
    textAlign: "right",
  },
  subListItemContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  totalAmount: {
    fontSize: 14,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginRight: 10,
  },
  barcodeImage: {
    display: "flex",
    width: "100%",
    justifyContent: "end",
  },
  circularProgressStyle: {
    marginTop: 15,
  },
  table: {
    borderColor: "white",
  },

  // button :{
  //   display: "block"
  // },
  // img :{
  //   display: "block"
  // },
  // video :{
  //   display: "block"
  // }
});

class SalesTabV2 extends React.Component {
  // componentDidMount() {
  //   var isBlurred = false;
  //   this.checkFocusInterval = setInterval(() => {
  //     const { selectedOrder, itemBarCode } = this.props.values;

  //     if (
  //       !IsEmpty(selectedOrder) &&
  //       selectedOrder.statusId === 16 &&
  //       this.textFieldRef &&
  //       !itemBarCode
  //     ) {
  //       this.textFieldRef.focus();
  //       isBlurred = false;
  //     } else if (
  //       this.textFieldRef &&
  //       itemBarCode &&
  //       !isBlurred &&
  //       !IsEmpty(selectedOrder) &&
  //       selectedOrder.statusId === 16
  //     ) {
  //       this.textFieldRef.blur(); // Unfocus when itemBarCode is populated
  //       isBlurred = true;
  //     }
  //   }, 5000); // Checks every 500ms, adjust as needed
  // }
  componentDidMount() {
    var isBlurred = false;
    this.checkFocusInterval = setInterval(() => {
      const { selectedOrder, itemBarCode, isAuthFieldActive } = this.props.values;

      // Don't steal focus if user is typing in User ID or Password fields
      if (isAuthFieldActive) return;

      if (
        !IsEmpty(selectedOrder) &&
        selectedOrder.statusId === 16 &&
        this.textFieldRef &&
        !itemBarCode
      ) {
        this.textFieldRef.focus();
        isBlurred = false;
      } else if (
        this.textFieldRef &&
        itemBarCode &&
        !isBlurred &&
        !IsEmpty(selectedOrder) &&
        selectedOrder.statusId === 16
      ) {
        this.textFieldRef.blur();
        isBlurred = true;
      }
    }, 5000);
  }
  componentWillUnmount() {
    clearInterval(this.checkFocusInterval); // Clean up the interval on unmount
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Card
          style={{
            minHeight: window.innerHeight - 120,
            maxHeight: window.innerHeight - 120,
          }}
          className={classes.card}
        >
          <CardHeader
            style={{ padding: 11 }}
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: 15,
                }}
              >
                <span className={classes.title}>
                  <ViewListIcon className={classes.titleIcon} />
                  <b>
                    Items (
                    {this.props.values.salesData.items &&
                      this.props.values.salesData.items.length}
                    )
                  </b>
                </span>
                <span>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    placeholder={
                      this.props.values.lastItemBarCode
                        ? "Scanned: " + this.props.values.lastItemBarCode
                        : "Item Barcode"
                    }
                    variant="outlined"
                    name="itemBarCode"
                    // eslint-disable-next-line react/prop-types
                    onBlur={this.props.onFocusOutItemBarCodeField}
                    disabled={
                      IsEmpty(this.props.values.selectedOrder) ||
                      this.props.values.selectedOrder.statusId != 16
                    }
                    inputRef={(ref) => (this.textFieldRef = ref)}
                    value={this.props.values.itemBarCode}
                    // eslint-disable-next-line react/prop-types
                    onChange={this.props.onHandleChange}
                  />
                </span>
              </div>
            }
          />
          <Divider className={classes.titleDivider} />
          <CardContent className={classes.cardContent}>
            {this.props.values.salesDataLoading ? (
              <div className={classes.circularProgressStyle}>
                <CircularProgress />
              </div>
            ) : (
              <>
                {this.props.values.salesData.items && (
                  <Fragment>
                    <TableContainer component={Paper}>
                      <Table
                        style={{ borderColor: "white" }}
                        aria-label="spanning table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Scanned</TableCell>
                            <TableCell>Category</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Size</TableCell>
                            <TableCell>Packaging</TableCell>
                            <TableCell>Product Thumbnail</TableCell>
                            <TableCell>Dispatched Img</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.props.values.salesData.items.map((sale) => (
                            <>
                              <TableRow key={sale.barcodeText}>
                                <TableCell
                                  style={{
                                    width: "10%",
                                    color:
                                      sale.isBarcodeScanned === 1
                                        ? "unset "
                                        : "darkgray",
                                  }}
                                  rowSpan={3}
                                >
                                  {sale.isBarcodeScanned == 1 ? (
                                    <>
                                      <div
                                        className={classes.image}
                                        style={{
                                          backgroundImage: `url(${scanImg})`,
                                          height: 30,
                                          width: 30,
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                        }}
                                      ></div>
                                      <br />
                                      <b>Status </b>
                                      <br />
                                      <span style={{ fontSize: 16 }}>
                                        {sale.statusLabel}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        className={classes.image}
                                        style={{
                                          backgroundImage: `url(${nonScannedImg})`,
                                          height: 30,
                                          width: 30,
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                        }}
                                      ></div>
                                      <br />
                                      <b>Status </b>
                                      <br />
                                      <span style={{ fontSize: 16 }}>
                                        {sale.statusLabel}
                                      </span>
                                    </>
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "15%",
                                    color:
                                      sale.isBarcodeScanned === 1
                                        ? "unset "
                                        : "darkgray",
                                  }}
                                  align="left"
                                  rowSpan={3}
                                >
                                  <div
                                    className={classes.image}
                                    style={{
                                      height: 30,

                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                    }}
                                  >
                                    {`${sale.productCategoryLabel}`}
                                  </div>

                                  <br />
                                  <b>Barcode </b>
                                  <br />
                                  <span style={{ fontSize: 16 }}>
                                    {sale.barcodeText}
                                  </span>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "20%",
                                    color:
                                      sale.isBarcodeScanned === 1
                                        ? "unset "
                                        : "darkgray",
                                  }}
                                  className={classes.table}
                                >
                                  <div style={{ lineHeight: 3 }}>
                                    {`${sale.productUserLabel}`}
                                  </div>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "10%",
                                    color:
                                      sale.isBarcodeScanned === 1
                                        ? "unset "
                                        : "darkgray",
                                  }}
                                  className={classes.table}
                                >
                                  <div style={{ lineHeight: 3 }}>
                                    {sale.productSizeLabel}
                                  </div>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "10%",
                                    color:
                                      sale.isBarcodeScanned === 1
                                        ? "unset "
                                        : "darkgray",
                                  }}
                                  rowSpan={3}
                                >
                                  {sale.isBarcodeScanned == 1 ? (
                                    <>
                                      <div
                                        style={{
                                          fontSize: 16,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          alt="img"
                                          style={{
                                            height: 85,
                                            width: 85,
                                            marginBottom: 5,
                                          }}
                                          src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${sale.productPackagingTypeAsset}`}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          fontSize: 16,
                                          textAlign: "center",
                                        }}
                                      >
                                        <span>
                                          {sale.productPackagingLabel}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          fontSize: 16,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          alt="img"
                                          style={{
                                            height: 85,
                                            width: 85,
                                            marginBottom: 5,
                                            opacity: 0.4,
                                          }}
                                          src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${sale.productPackagingTypeAsset}`}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          fontSize: 16,
                                          textAlign: "center",
                                        }}
                                      >
                                        <span>
                                          {sale.productPackagingLabel}
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "20%",
                                    color:
                                      sale.isBarcodeScanned === 1
                                        ? "unset "
                                        : "darkgray",
                                  }}
                                  rowSpan={3}
                                >
                                  {sale.isBarcodeScanned == 1 ? (
                                    <div
                                      onClick={() =>
                                        // eslint-disable-next-line react/prop-types
                                        this.props.onImageClick(sale)
                                      }
                                      style={{
                                        display: "flex",
                                        textAlign: "center",
                                      }}
                                    >
                                      <img
                                        alt="img"
                                        style={{
                                          height: 115,
                                          width:
                                            sale.productCategoryLabel ==
                                              "Theme Mug" ||
                                              sale.productCategoryLabel ==
                                              "Themed Photobook" ||
                                              sale.productCategoryLabel ==
                                              "Custom Photobook"
                                              ? 180
                                              : 120,
                                          marginBottom: 5,
                                        }}
                                        src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${sale.firstImageFileName}`}
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() =>
                                        // eslint-disable-next-line react/prop-types
                                        this.props.onImageClick(sale)
                                      }
                                      style={{
                                        display: "flex",
                                        textAlign: "center",
                                      }}
                                    >
                                      <img
                                        alt="img"
                                        style={{
                                          height: 115,
                                          width:
                                            sale.productCategoryLabel ==
                                              "Theme Mug" ||
                                              sale.productCategoryLabel ==
                                              "Themed Photobook" ||
                                              sale.productCategoryLabel ==
                                              "Custom Photobook"
                                              ? 180
                                              : 120,
                                          marginBottom: 5,
                                          opacity: 0.4,
                                        }}
                                        src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${sale.firstImageFileName}`}
                                      />
                                    </div>
                                  )}
                                </TableCell>

                                <TableCell
                                  style={{ width: "20%" }}
                                  rowSpan={3}
                                  className={classes.table}
                                >
                                  {sale.isDispatchedImageCapture == 0 ? (
                                    sale.isBarcodeScanned == 1 ? (
                                      <div
                                        onClick={() =>
                                          // eslint-disable-next-line react/prop-types
                                          this.props.handleCaptureImageViewerToggle(
                                            sale
                                          )
                                        }
                                        style={{
                                          height: 115,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          border: "3px solid #dbe4ed",
                                        }}
                                      >
                                        <img
                                          alt="img"
                                          style={{
                                            height: 50,
                                            width: 50,
                                            marginBottom: 5,
                                          }}
                                          src={cameraImg}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          height: 115,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          border: "3px solid #dbe4ed",
                                        }}
                                      >
                                        <img
                                          alt="img"
                                          style={{
                                            height: 50,
                                            width: 50,
                                            marginBottom: 5,
                                            opacity: 0.4,
                                          }}
                                          src={cameraImg}
                                        />
                                      </div>
                                    )
                                  ) : (
                                    <img
                                      alt="img"
                                      style={{
                                        height: 115,
                                        width: 150,
                                        marginBottom: 5,
                                      }}
                                      src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${sale.dispatchedImage}`}
                                    />
                                  )}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  className={classes.table}
                                ></TableCell>
                                <TableCell
                                  className={classes.table}
                                ></TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            </>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Fragment>
                )}
              </>
            )}
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

SalesTabV2.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  getImagesOrderIdAndProductId: PropTypes.func,
  handleQACheckList: PropTypes.func,
};

SalesTabV2.defaultProps = {
  values: {},
  getImagesOrderIdAndProductId: (fn) => fn,
  handleQACheckList: (fn) => fn,
};

export default withStyles(useStyles)(SalesTabV2);
